export default __webpack_public_path__ + "static/media/kuraikinui.1874da50.webp";